export const COOKIE_CONFIG = {
  expires: 365
}
